import { HTTPError } from "ky";
import {
	type CardCheck,
	type CardReward,
	EMPTY_CARD,
	type Redemption,
} from "@/features/card/api/types";
import { api, publicApi, readApiError } from "@/shared/api/client";

export async function fetchCardCheck(code: string): Promise<CardCheck> {
	try {
		return await publicApi
			.get(`cards/${encodeURIComponent(code)}`, {
				cache: "no-store",
			})
			.json();
	} catch (error) {
		if (error instanceof HTTPError && error.response.status === 404) {
			return EMPTY_CARD;
		}
		throw error;
	}
}

export async function fetchCardRewards(code: string): Promise<CardReward[]> {
	try {
		return await publicApi
			.get(`cards/${encodeURIComponent(code)}/rewards`, {
				cache: "no-store",
			})
			.json();
	} catch (error) {
		if (error instanceof HTTPError && error.response.status === 404) {
			return [];
		}
		throw error;
	}
}

export async function redeemReward(
	code: string,
	input: { rewardId: string; idempotencyKey: string },
): Promise<Redemption> {
	try {
		return await api
			.post(`cards/${encodeURIComponent(code)}/redemptions`, {
				json: input,
			})
			.json();
	} catch (error) {
		if (error instanceof HTTPError) {
			const body = await readApiError(error.response);
			const err = new Error(body.code ?? "REDEEM_FAILED") as Error & {
				code?: string;
			};
			err.code = body.code;
			throw err;
		}
		throw error;
	}
}
